import React, { useState, useEffect } from 'react'
import {
  FlexboxGrid,
  Grid,
  Row,
  Col,
  Panel,
  Table,
  SelectPicker,
  InputGroup,
  InputNumber,
  RangeSlider,
  CheckPicker,
  CheckTreePicker,
  Button,
  Icon,
} from 'rsuite'
import TopLevelNav from '../../../components/TopLevelNav'
import PageToolbar from '../../../components/PageToolbar'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'
import PanalLoadingTemplate from '../../loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { doneLoading, startLoading } from '../../../utils/loading'
import ErrorWidget from '../../errorWidget/ErrorWidget'
import './styles.css'

import PerformanceStepChart from '../..//dashboard/charts/PerformanceStepChart'
import DimensionalCompetence4Chart from '../..//dashboard/charts/DimensionalCompetence4Chart'
import OverallNodeProvinceChart from '../..//dashboard/charts/OverallNodeProvinceChart'
import { Controller, useForm } from 'react-hook-form'
import {
  getOverAllOperations4areas,
  searchOverAllOperations4areas,
} from '../../../redux/actions/dashboardDep6'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'

export default function OverAllOperations4areas() {
  const { register, handleSubmit, errors, control, reset, clearErrors } = useForm()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [schema, setSchema] = useState()

  const [sortColumn, setSortColumn] = useState()
  const [sortType, setSortType] = useState()
  const [isLoadingTable, setIsLoadingTable] = useState(false)

  const { Column, HeaderCell, Cell, Pagination } = Table

  const [levelPerformanceLadder, setLevelPerformanceLadder] = useState()
  const [areaProvince, setAreaProvince] = useState()
  const [tableRegionId, setTableRegionId] = useState()
  const [tableProvinceId, setTableProvinceId] = useState()

  const [questingOfYear, setQuestingOfYear] = useState()
  const [stairsLevel, setStairsLevel] = useState()
  const [regionId, setRegionId] = useState()
  const [provinceId, setProvinceId] = useState()
  const [districeId, setDistriceId] = useState()
  const [provincialManagementUnit, setProvincialManagementUnit] = useState()
  const [criOrderBy, setCriOrderBy] = useState()
  const [location, setLocation] = useState()

  // const [tableRowIsOpening, setTableRowIsOpening] = useState(true)

  const _styles = {
    panel: {
      backgroundColor: '#34a888',
    },
    titleMesage: {
      color: '#ffffff',
    },
    content: {
      marginTop: 20,
    },
    icon: {
      paddingRight: 10,
    },
    footer: {
      marginTop: 15,
    },
    button: {
      width: 120,
      color: '#ffffff',
      backgroundColor: '#575757',
      fontWeight: 'bold',
      fontSize: '14 !important',
    },
  }

  useEffect(() => {
    // console.log('load ref ID => ', referenceID)

    handleGetResponse()
  }, [])

  const mockSchema = {
    forms: {
      header: 'รายงานผลการประเมินสมรรถนะหน่วยจัดการ',
      dashboardInfo: {
        performanceLadder: {
          title: 'ผลสมรรถนะขั้นบันได',
          setting: {
            legendData: ['ขั้นที่ 1', 'ขั้นที่ 2', 'ขั้นที่ 3', 'ขั้นที่ 4'],
            seriesData: [
              { value: 40, name: 'ขั้นที่ 4' },
              { value: 60, name: 'ขั้นที่ 3' },
              { value: 80, name: 'ขั้นที่ 2' },
              { value: 100, name: 'ขั้นที่ 1' },
            ],
          },
        },
        overviewPerformance: {
          title: 'ข้อมูลภาพรวมผลประเมินสมรรถนะหน่วยจัดการจังหวัด',
          setting: {
            // legendData: ['ขั้นที่ 1', 'ขั้นที่ 2', 'ขั้นที่ 3', 'ขั้นที่ 4'],
            radarIndicator: [
              { name: 'หัวหน้าหน่วยจัดการ', max: 30000 },
              { name: 'พี่เลี้ยง', max: 30000 },
              { name: 'บริหารจัดการ', max: 30000 },
              { name: 'โครงการย่อย', max: 38000 },
            ],
            seriesData: [
              {
                value: [5000, 14000, 28000, 26000],
                // value: [
                //   { id: '111', value: 5000 },
                //   { id: '222', value: 14000 },
                //   { id: '333', value: 28000 },
                //   { id: '444', value: 26000 },
                // ],
              },
            ],
          },
        },
        performanceHeadManagement: {
          title: 'ผลประเมินสมรรนะหัวหน้าหน่วยจัดการ',
          setting: {
            radarIndicator: [
              { name: 'ความร่วมมือ', max: 30000 },
              { name: 'โครงสร้างทีม', max: 30000 },
              { name: 'การจัดการเวลา', max: 30000 },
              { name: 'ถ่ายทดหลักการ', max: 38000 },
              { name: 'บริหารจัดการ', max: 38000 },
              { name: 'ให้คำปรึกษา', max: 38000 },
              { name: 'แผนพัฒนาศักยภาพ', max: 38000 },
              { name: 'จัดกิจกรรมพัฒนาศักยภาพ', max: 38000 },
            ],
            seriesData: [
              {
                value: [5000, 14000, 28000, 26000, 5000, 14000, 28000, 26000],
              },
            ],
          },
        },
        performanceManagementUnitMentors: {
          title: 'ผลประเมินสมรรถนะพี่เลี้ยงหน่วยจัดการ',
          setting: {
            radarIndicator: [
              { name: 'อบรมติดตาม ARE', max: 30000 },
              { name: 'อบรมพัฒนาโครงการ', max: 30000 },
              { name: 'สนับสนุนชุมชนออก...', max: 30000 },
              { name: 'ทำแผนการติดตาม', max: 38000 },
              { name: 'สนับสนุนชุมชนเก็บข้อมูล', max: 38000 },
              { name: 'ติดตาม เสริมพลัง', max: 38000 },
              { name: 'ถ่ายทอดเรื่อง ARE', max: 38000 },
              { name: 'ทักษะการพัฒนาโครงการ', max: 38000 },
              { name: 'อบรมติดตาม ARE', max: 38000 },
            ],
            seriesData: [
              {
                value: [5000, 14000, 28000, 26000, 5000, 14000, 28000, 26000, 26000],
              },
            ],
          },
        },
        performanceResultManagementUnit: {
          title: 'ผลประเมินประสิทธิภาพการบริหารจัดการหน่วยจัดการ',
          setting: {
            radarIndicator: [
              { name: 'การกระจายโอกาส', max: 30000 },
              { name: 'บริหารจัดการโครงการย่อย', max: 30000 },
              { name: 'การเงินและบัญชี', max: 30000 },
              { name: 'ชี้เป้าโครงการเด่น', max: 38000 },
              { name: 'การสื่อสารภายนอก', max: 38000 },
              { name: 'คุณภาพกระบวนการ ARE', max: 38000 },
              { name: 'การสื่อสารภายในทีม', max: 38000 },
              { name: 'คุณภาพโครงการขนาดเล็ก', max: 38000 },
              { name: 'การวิเคราะห์และแผนกภาคีเครือข่าย', max: 38000 },
              { name: 'การวิเคราะห์และแผนภาคีเครือข่าย', max: 38000 },
              { name: 'คุณภาพโครงการทั่วไป', max: 38000 },
              { name: 'ความร่วมมือกับภาคี', max: 38000 },
              { name: 'คุณภาพของบทเรียน คก. ย่อย', max: 38000 },
              { name: 'คุณภาพของการสื่อสารสาธารณะ', max: 38000 },
            ],
            seriesData: [
              {
                value: [
                  5000, 14000, 28000, 26000, 5000, 14000, 28000, 26000, 26000, 13000, 30000, 14000,
                  28000, 5000,
                ],
              },
            ],
          },
        },
        subprojectUndertheManagement: {
          title: 'ผลประเมินความสำเร็จโครงการย่อยภายใต้หน่วยจัดการ',
          setting: {
            radarIndicator: [
              { name: 'จำนวนโครงการที่มีแนวโน้มต่อเนื่อง', max: 30000 },
              { name: 'จำนวนของโครงการที่มีความโดดเด่น', max: 30000 },
              { name: 'จำนวนโครงการย่อยที่บรรลุผลลัพ', max: 30000 },
            ],
            seriesData: [
              {
                value: [5000, 14000, 28000],
              },
            ],
          },
        },
        numberProjectProvince: {
          title: 'จำนวนโครงการรายจังหวัด',
          setting: {
            seriesData: [
              { name: 'กรุงเทพมหานคร', value: 5588000 },
              { name: 'พระนครศรีอยุธยา', value: 1 },
              { name: 'กระบี่', value: 467000 },
              { name: 'กาญจนบุรี', value: 887000 },
              { name: 'กาฬสินธุ์', value: 998000 },
              { name: 'กำแพงเพชร', value: 745000 },
              { name: 'ขอนแก่น', value: 1796000 },
              { name: 'จันทบุรี', value: 527000 },
              { name: 'ฉะเชิงเทรา', value: 709000 },
              { name: 'สุโขทัย', value: 611000 },
              { name: 'สุพรรณบุรี', value: 863000 },
              { name: 'สุราษฎร์ธานี', value: 1040000 },
              { name: 'สุรินทร์', value: 1393000 },
              { name: 'หนองคาย', value: 520000 },
              { name: 'หนองบัวลำภู', value: 508000 },
              { name: 'อ่างทอง', value: 284000 },
              { name: 'อำนาจเจริญ', value: 383000 },
              { name: 'อุดรธานี', value: 1568000 },
              { name: 'อุตรดิตถ์', value: 460000 },
              { name: 'อุทัยธานี', value: 335000 },
              { name: 'อุบลราชธานี', value: 1882000 },
            ],
          },
        },
        projectDetail: {
          title: 'คะแนนเฉลี่ยสมรรถนะ Node 4 ด้าน',
          values: [
            {
              id: '1',
              labelName: 'ภาคเหนือ',
              subproject: '2.41',
              management: '1.99',
              coach: '1.99',
              leader: '2.27',
              total: '2.17',
              children: [
                {
                  id: '1-1',
                  labelName: 'เชียงราย',
                  subproject: '2.70',
                  management: '2.40',
                  coach: '2.33',
                  leader: '2.25',
                  total: '2.42',
                },
              ],
            },
            {
              id: '999',
              labelName: 'Total',
              subproject: '0',
              management: '1',
              coach: '2',
              leader: '3',
              total: '4',
            },
          ],
        },
      },
      searchForms: {
        questingsOfYear: {
          name: 'questingsOfYear',
          label: 'โจทย์ประเมินผลปี',
          value: '',
          options: [
            { disabled: false, label: 'ทั้งหมด', value: '9999' },
            { disabled: false, label: '2566', value: '2566' },
            { disabled: false, label: '2567', value: '2567' },
          ],
        },
        stairsLevel: {
          name: 'stairsLevel',
          label: 'ขั้นบันใด',
          options: [
            { disabled: false, label: 'ขั้นที่ 1', value: '1' },
            { disabled: false, label: 'ขั้นที่ 2', value: '2' },
            { disabled: false, label: 'ขั้นที่ 3', value: '3' },
          ],
        },
        location: {
          name: 'location',
          label: 'ภาค, จังหวัด, อำเภอ',
          options: [
            {
              label: 'ภาค',
              value: 1,
              children: [
                {
                  label: 'จังหวัด',
                  value: 11,
                },
              ],
            },
          ],
        },
        button: {
          search: {
            setCol: { xxs: 24, xsm: 24, xmd: 24, xlg: 12 },
            label: 'ค้นหา',
          },
          cancel: {
            setCol: { xxs: 24, xsm: 24, xmd: 24, xlg: 24 },
            label: 'ยกเลิก',
          },
          exportExcel: {
            setCol: { xxs: 24, xsm: 24, xmd: 24, xlg: 12 },
            label: 'Download Excel',
          },
        },
      },
    },
  }

  const handleGetResponse = async () => {
    setIsLoading(true)
    startLoading()

    try {
      const res = await getOverAllOperations4areas()
      console.log('res => ', res)

      setSchema(res.forms)
    } catch (e) {
      console.log('error => ', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }

    doneLoading()
    setIsLoading(false)
  }

  const handleSortColumn = (sortColumn, sortType) => {
    console.log('handleSortColumn => ', sortColumn, sortType)
    setIsLoadingTable(true)

    handleClickSearch('criOrderBy', `${sortColumn}_${sortType}`)

    setTimeout(() => {
      setSortColumn(sortColumn)
      setSortType(sortType)
      setIsLoadingTable(false)
    }, 500)
  }

  const handleCancel = () => {
    console.log('handleCancel')

    setLevelPerformanceLadder()
    setQuestingOfYear()
    setStairsLevel()
    setRegionId()
    setProvinceId()
    setDistriceId()
    setProvincialManagementUnit()
    setAreaProvince()
    setTableRegionId()
    setTableProvinceId()
    setCriOrderBy()
    setLocation()
  }

  const handleExportExcel = () => {
    alert('handleExportExcel')
  }

  const callApiSearch = async (req) => {
    setIsLoading(true)
    startLoading()

    try {
      var response = await searchOverAllOperations4areas(req)
      console.log('resssss => ', response)
      setSchema(response.forms)
    } catch (e) {
      console.log('error => ', e)
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 2500,
      })
    }

    doneLoading()
    setIsLoading(false)
  }

  const handleSearch = async () => {
    let regionIdArr = []
    let provinceIdArr = []
    let districtIdArr = []

    if (location?.length > 0) {
      location.map((item) => {
        let itemSplit = item?.split('||')
        if (itemSplit.length > 0) {
          if (itemSplit[1] == 'DISTRICT') {
            districtIdArr.push(itemSplit[0])
          } else if (itemSplit[1] == 'REGION') {
            regionIdArr.push(itemSplit[0])
          } else if (itemSplit[1] == 'PROVINCE') {
            provinceIdArr.push(itemSplit[0])
          }
        }
      })
    }

    const req = {
      levelPerformanceLadder: levelPerformanceLadder || '',
      questingOfYear: questingOfYear?.length > 0 ? questingOfYear.toString() : '',
      stairsLevel: stairsLevel?.length > 0 ? stairsLevel.toString() : '',
      regionId: regionIdArr?.length > 0 ? regionIdArr.toString() : '',
      provinceId: provinceIdArr?.length > 0 ? provinceIdArr.toString() : '',
      districeId: districtIdArr?.length > 0 ? districtIdArr.toString() : '',
      provincialManagementUnit:
        provincialManagementUnit?.length > 0 ? provincialManagementUnit.toString() : '',
      areaProvince: areaProvince || '',
      tableRegionId: tableRegionId || '',
      tableProvinceId: tableProvinceId || '',
      criOrderBy: criOrderBy || '',
    }

    await callApiSearch(req)
  }

  const handleClickSearch = async (ctype = null, cid = null) => {
    let regionIdArr = []
    let provinceIdArr = []
    let districtIdArr = []

    if (location?.length > 0) {
      location.map((item) => {
        let itemSplit = item?.split('||')
        if (itemSplit.length > 0) {
          if (itemSplit[1] == 'DISTRICT') {
            districtIdArr.push(itemSplit[0])
          } else if (itemSplit[1] == 'REGION') {
            regionIdArr.push(itemSplit[0])
          } else if (itemSplit[1] == 'PROVINCE') {
            provinceIdArr.push(itemSplit[0])
          }
        }
      })
    }

    const req = {
      levelPerformanceLadder:
        ctype == 'levelPerformanceLadder' ? cid || '' : levelPerformanceLadder || '',
      questingOfYear: questingOfYear?.length > 0 ? questingOfYear.toString() : '',
      stairsLevel: stairsLevel?.length > 0 ? stairsLevel.toString() : '',
      regionId: regionIdArr?.length > 0 ? regionIdArr.toString() : '',
      provinceId: provinceIdArr?.length > 0 ? provinceIdArr.toString() : '',
      districeId: districtIdArr?.length > 0 ? districtIdArr.toString() : '',
      provincialManagementUnit:
        provincialManagementUnit?.length > 0 ? provincialManagementUnit.toString() : '',
      areaProvince: ctype == 'areaProvince' ? cid || '' : areaProvince || '',
      tableRegionId: ctype == 'tableRegion' ? cid || '' : tableRegionId || '',
      tableProvinceId: ctype == 'tableProvince' ? cid || '' : tableProvinceId || '',
      criOrderBy: criOrderBy || '',
    }

    switch (ctype) {
      case 'levelPerformanceLadder':
        setLevelPerformanceLadder(cid)
        break

      case 'areaProvince':
        setAreaProvince(cid)
        break

      case 'tableRegion':
        setTableRegionId(cid)
        break

      case 'tableProvince':
        setTableProvinceId(cid)
        break

      default:
        break
    }

    await callApiSearch(req)
  }

  if (error) {
    return (
      <Row>
        <Col xs={24} sm={24} md={24} lg={24}>
          <ErrorWidget statusCode={error?.statusCode} errorMessage={error?.errorMessage} />
        </Col>
      </Row>
    )
  }

  if (!schema || isLoading) {
    return (
      <Row>
        <Col xs={24} sm={24} md={24} lg={24}>
          <OverlayLoader />
          <PanalLoadingTemplate />
        </Col>
      </Row>
    )
  }

  const CardAmt = (props) => {
    console.log('props => ', props)
    return (
      <Panel {...props} bordered className="card-amt-panel">
        <Row>
          <Col md={24} sm={24} xs={24} className="card-amt-row-header">
            {props.data.header}
          </Col>
        </Row>
        <Row className="card-amt-row-value">
          <Col md={24} sm={24} xs={24} style={{ textAlign: 'center' }}>
            {props.data.value}
          </Col>
        </Row>
      </Panel>
    )
  }

  return (
    <>
      <div style={{ marginTop: 50, fontSize: 16 }}>
        {schema.header && (
          <Panel bordered bodyFill style={{ marginTop: 5 }}>
            <Row>
              <Col xs={24} sm={24} md={24} lg={24} className="dashboard-header">
                <p className="dashboard-header-txt">{schema?.header || ''}</p>
              </Col>
            </Row>
          </Panel>
        )}

        {schema?.dashboardInfo && (
          <Row>
            <Col xs={24} sm={24} md={18} lg={18}>
              <Panel bordered collapsible defaultExpanded style={{ marginTop: 5 }} header={`  `}>
                <Row>
                  {schema?.dashboardInfo?.performanceLadder && (
                    <Col xs={24} sm={24} md={24} lg={24}>
                      <Row>
                        <Col xs={24} sm={24} md={24} lg={24}>
                          <div className="title-view">
                            {schema?.dashboardInfo?.performanceLadder?.title || ''}
                          </div>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={24}>
                          <PerformanceStepChart
                            legendData={
                              schema?.dashboardInfo?.performanceLadder?.setting?.legendData || []
                            }
                            seriesData={
                              schema?.dashboardInfo?.performanceLadder?.setting?.seriesData || []
                            }
                            onClickCheart={(param) => {
                              handleClickSearch('levelPerformanceLadder', param.id)
                            }}
                          />
                        </Col>
                      </Row>
                    </Col>
                  )}

                  {schema?.dashboardInfo?.overviewPerformance && (
                    <Col xs={24} sm={24} md={24} lg={24}>
                      <Row>
                        <Col xs={24} sm={24} md={24} lg={24}>
                          <div className="title-view">
                            {schema?.dashboardInfo?.overviewPerformance?.title || ''}
                          </div>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={24}>
                          <DimensionalCompetence4Chart
                            radarIndicator={
                              schema?.dashboardInfo?.overviewPerformance?.setting
                                ?.radarIndicators || []
                            }
                            seriesData={
                              schema?.dashboardInfo?.overviewPerformance?.setting?.seriesData || []
                            }
                          />
                        </Col>
                      </Row>
                    </Col>
                  )}

                  {schema?.dashboardInfo?.performanceHeadManagement && (
                    <Col xs={24} sm={24} md={12} lg={12}>
                      <Row>
                        <Col xs={24} sm={24} md={24} lg={24}>
                          <div className="title-view">
                            {schema?.dashboardInfo?.performanceHeadManagement?.title || ''}
                          </div>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={24}>
                          <DimensionalCompetence4Chart
                            radarIndicator={
                              schema?.dashboardInfo?.performanceHeadManagement?.setting
                                ?.radarIndicators || []
                            }
                            seriesData={
                              schema?.dashboardInfo?.performanceHeadManagement?.setting
                                ?.seriesData || []
                            }
                          />
                        </Col>
                      </Row>
                    </Col>
                  )}

                  {schema?.dashboardInfo?.performanceResultManagementUnit && (
                    <Col xs={24} sm={24} md={12} lg={12}>
                      <Row>
                        <Col xs={24} sm={24} md={24} lg={24}>
                          <div className="title-view">
                            {schema?.dashboardInfo?.performanceResultManagementUnit?.title || ''}
                          </div>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={24}>
                          <DimensionalCompetence4Chart
                            radarIndicator={
                              schema?.dashboardInfo?.performanceResultManagementUnit?.setting
                                ?.radarIndicators || []
                            }
                            seriesData={
                              schema?.dashboardInfo?.performanceResultManagementUnit?.setting
                                ?.seriesData || []
                            }
                          />
                        </Col>
                      </Row>
                    </Col>
                  )}

                  {schema?.dashboardInfo?.performanceResultManagementUnit && (
                    <Col xs={24} sm={24} md={12} lg={12}>
                      <Row>
                        <Col xs={24} sm={24} md={24} lg={24}>
                          <div className="title-view">
                            {schema?.dashboardInfo?.performanceResultManagementUnit?.title || ''}
                          </div>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={24}>
                          <DimensionalCompetence4Chart
                            radarIndicator={
                              schema?.dashboardInfo?.performanceResultManagementUnit?.setting
                                ?.radarIndicators || []
                            }
                            seriesData={
                              schema?.dashboardInfo?.performanceResultManagementUnit?.setting
                                ?.seriesData || []
                            }
                          />
                        </Col>
                      </Row>
                    </Col>
                  )}

                  {schema?.dashboardInfo?.subprojectUndertheManagement && (
                    <Col xs={24} sm={24} md={12} lg={12}>
                      <Row>
                        <Col xs={24} sm={24} md={24} lg={24}>
                          <div className="title-view">
                            {schema?.dashboardInfo?.subprojectUndertheManagement?.title || ''}
                          </div>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={24}>
                          <DimensionalCompetence4Chart
                            radarIndicator={
                              schema?.dashboardInfo?.subprojectUndertheManagement?.setting
                                ?.radarIndicators || []
                            }
                            seriesData={
                              schema?.dashboardInfo?.subprojectUndertheManagement?.setting
                                ?.seriesData || []
                            }
                          />
                        </Col>
                      </Row>
                    </Col>
                  )}

                  <Col xs={24} sm={24} md={24} lg={24}>
                    <Row>
                      {schema?.dashboardInfo?.numberProjectProvince && (
                        <Col xs={24} sm={24} md={8} lg={8}>
                          <Row>
                            <Col xs={24} sm={24} md={24} lg={24}>
                              <div className="title-view">
                                {schema?.dashboardInfo?.numberProjectProvince?.title || ''}
                              </div>
                            </Col>
                            <Col xs={24} sm={24} md={24} lg={24}>
                              <OverallNodeProvinceChart
                                seriesData={
                                  schema?.dashboardInfo?.numberProjectProvince?.setting
                                    ?.seriesData || []
                                }
                                onClickCheart={(param) => {
                                  if (!param?.id) {
                                    return false
                                  }
                                  handleClickSearch('areaProvince', param.id)
                                }}
                              />
                            </Col>
                          </Row>
                        </Col>
                      )}

                      {schema?.dashboardInfo?.projectDetail && (
                        <Col xs={24} sm={24} md={16} lg={16}>
                          <Row>
                            <Col xs={24} sm={24} md={24} lg={24}>
                              <div className="title-view">
                                {schema?.dashboardInfo?.projectDetail?.title}
                              </div>
                            </Col>
                            <Col xs={24} sm={24} md={24} lg={24}>
                              <Table
                                isTree
                                defaultExpandAllRows
                                rowKey="id"
                                height={400}
                                headerHeight={60}
                                wordWrap
                                data={schema?.dashboardInfo?.projectDetail?.values || []}
                                onExpandChange={(isOpen, rowData) => {
                                  // console.log(isOpen, rowData)
                                }}
                                renderTreeToggle={(icon, rowData) => {
                                  if (rowData.children && rowData.children.length === 0) {
                                    // return <Icon icon="data-decrease" />
                                    return (
                                      <p
                                        style={{
                                          fontWeight: 'bold',
                                          fontSize: 24,
                                          color: '#8e8e93',
                                        }}
                                      >
                                        -
                                      </p>
                                    )
                                  }
                                  return icon
                                }}
                                sortColumn={sortColumn}
                                sortType={sortType}
                                onSortColumn={handleSortColumn}
                                loading={isLoadingTable}
                                // onRowClick={(data) => {
                                //   // console.log('ffff => ', tableRowIsOpening)
                                //   console.log('gggg => ', data)
                                // }}
                                // className="table-data"
                              >
                                <Column width={50} align="center">
                                  <HeaderCell>#</HeaderCell>
                                  <Cell></Cell>
                                </Column>
                                <Column minWidth={200} flexGrow={1}>
                                  <HeaderCell>ภาค</HeaderCell>
                                  {/* <Cell dataKey="labelName" /> */}
                                  <Cell>
                                    {(rowData) => {
                                      return (
                                        <Button
                                          appearance="link"
                                          onClick={() => {
                                            if (rowData?.id) {
                                              let subId = rowData?.id.split('||')

                                              console.log('subId ', subId)

                                              if (subId?.length > 0 && subId[1]) {
                                                if (subId[1] == 'REGION') {
                                                  handleClickSearch('tableRegion', subId[0])
                                                } else if (subId[1] == 'PROVINCE') {
                                                  handleClickSearch('tableProvince', subId[0])
                                                }
                                              }
                                            }
                                          }}
                                        >
                                          {rowData.labelName}
                                        </Button>
                                      )
                                      // return <div dangerouslySetInnerHTML={{ __html: rowData.value }} />
                                    }}
                                  </Cell>
                                </Column>

                                <Column width={100} align="right">
                                  <HeaderCell>โครงการย่อย</HeaderCell>
                                  <Cell dataKey="subproject" />
                                </Column>

                                <Column width={100} align="right">
                                  <HeaderCell>บริหารจัดการ</HeaderCell>
                                  <Cell dataKey="management" />
                                </Column>

                                <Column width={100} align="right">
                                  <HeaderCell>พี่เลี้ยง</HeaderCell>
                                  <Cell dataKey="coach" />
                                </Column>

                                <Column width={100} align="right">
                                  <HeaderCell>หัวหน้าหน่วยจัดการ</HeaderCell>
                                  <Cell dataKey="leader" />
                                </Column>

                                <Column width={100} align="right" sortable>
                                  <HeaderCell>Total</HeaderCell>
                                  <Cell dataKey="total" />
                                </Column>
                              </Table>
                            </Col>
                          </Row>
                        </Col>
                      )}
                    </Row>
                  </Col>
                </Row>
              </Panel>
            </Col>
            <Col xs={24} sm={24} md={6} lg={6}>
              <Panel bordered collapsible defaultExpanded style={{ marginTop: 5 }} header={`  `}>
                {schema?.searchForms?.questingsOfYear && (
                  <Row className="filter-box">
                    <Col xs={24} sm={24} md={24} lg={24}>
                      <div className="filter-title">
                        {schema?.searchForms?.questingsOfYear?.label || ''}
                      </div>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={24}>
                      <div className="filter-box-input">
                        <Controller
                          name={schema?.searchForms?.questingsOfYear.name}
                          control={control}
                          render={(props) => {
                            return (
                              <CheckPicker
                                data={schema?.searchForms?.questingsOfYear.options || []}
                                // value={props.value}
                                value={questingOfYear || []}
                                placeholder="เลือก"
                                block
                                onChange={(value) => {
                                  props.onChange(value)
                                  setQuestingOfYear(value)
                                }}
                              />
                            )
                          }}
                        />
                      </div>
                    </Col>
                  </Row>
                )}

                {schema?.searchForms?.stairsLevel && (
                  <Row className="filter-box">
                    <Col xs={24} sm={24} md={24} lg={24}>
                      <div className="filter-title">
                        {schema?.searchForms?.stairsLevel?.label || ''}
                      </div>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={24}>
                      <div className="filter-box-input">
                        <Controller
                          name={schema?.searchForms?.stairsLevel.name}
                          control={control}
                          render={(props) => {
                            return (
                              <CheckPicker
                                data={schema?.searchForms?.stairsLevel.options || []}
                                // value={props.value}
                                value={stairsLevel || []}
                                placeholder="เลือก"
                                block
                                onChange={(value) => {
                                  props.onChange(value)
                                  setStairsLevel(value)
                                }}
                              />
                            )
                          }}
                        />
                      </div>
                    </Col>
                  </Row>
                )}

                {schema?.searchForms?.location && (
                  <Row className="filter-box">
                    <Col xs={24} sm={24} md={24} lg={24}>
                      <div className="filter-title">
                        {schema?.searchForms?.location?.label || ''}
                      </div>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={24}>
                      <div className="filter-box-input">
                        <Controller
                          name={schema?.searchForms?.location?.name}
                          control={control}
                          render={(props) => {
                            return (
                              <CheckTreePicker
                                defaultExpandAll={false}
                                data={schema?.searchForms?.location.options || []}
                                name
                                block
                                placeholder="เลือก"
                                value={location || []}
                                // value={props.value}
                                renderTreeNode={(nodeData) => {
                                  return nodeData.label
                                }}
                                renderValue={(value, checkedItems) => {
                                  // let arrId =
                                  //   checkedItems?.map((item) => item.value)?.join(' , ') || null
                                  // setLocation(arrId)

                                  return (
                                    <span>
                                      {checkedItems.map((item) => item.label).join(' , ')}
                                    </span>
                                  )
                                }}
                                onChange={(value) => {
                                  // console.log('onChange => ', value)
                                  setLocation(value)
                                  // setValue(schema?.searchForms?.location?.name, value)
                                }}
                              />
                            )
                          }}
                        />
                      </div>
                    </Col>
                  </Row>
                )}

                {schema?.searchForms?.provincialManagementUnit && (
                  <Row className="filter-box">
                    <Col xs={24} sm={24} md={24} lg={24}>
                      <div className="filter-title">
                        {schema?.searchForms?.provincialManagementUnit?.label || ''}
                      </div>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={24}>
                      <div className="filter-box-input">
                        <Controller
                          name={schema?.searchForms?.provincialManagementUnit.name}
                          control={control}
                          render={(props) => {
                            return (
                              <CheckPicker
                                data={schema?.searchForms?.provincialManagementUnit.options || []}
                                // value={props.value}
                                value={provincialManagementUnit || []}
                                placeholder="เลือก"
                                block
                                onChange={(value) => {
                                  props.onChange(value)
                                  setProvincialManagementUnit(value)
                                }}
                              />
                            )
                          }}
                        />
                      </div>
                    </Col>
                  </Row>
                )}

                {schema?.searchForms?.button && (
                  <Row className="filter-box">
                    {schema?.searchForms?.button?.search && (
                      <Col
                        xs={schema?.searchForms?.button?.search?.setCol.xxs}
                        sm={schema?.searchForms?.button?.search?.setCol.xsm}
                        md={schema?.searchForms?.button?.search?.setCol.xmd}
                        lg={schema?.searchForms?.button?.search?.setCol.xlg}
                      >
                        <SaveButton
                          icon={'search'}
                          block
                          children={schema?.searchForms?.button?.search?.label}
                          onClick={() => {
                            handleSearch()
                          }}
                        />
                      </Col>
                    )}

                    {schema?.searchForms?.button?.exportExcel && (
                      <Col
                        xs={schema?.searchForms?.button?.exportExcel?.setCol.xxs}
                        sm={schema?.searchForms?.button?.exportExcel?.setCol.xsm}
                        md={schema?.searchForms?.button?.exportExcel?.setCol.xmd}
                        lg={schema?.searchForms?.button?.exportExcel?.setCol.xlg}
                      >
                        <SaveButton
                          icon={'file-excel-o'}
                          block
                          children={schema?.searchForms?.button?.exportExcel?.label}
                          onClick={() => {
                            handleExportExcel()
                          }}
                        />
                      </Col>
                    )}

                    {schema?.searchForms?.button?.cancel && (
                      <Col
                        xs={schema?.searchForms?.button?.cancel?.setCol.xxs}
                        sm={schema?.searchForms?.button?.cancel?.setCol.xsm}
                        md={schema?.searchForms?.button?.cancel?.setCol.xmd}
                        lg={schema?.searchForms?.button?.cancel?.setCol.xlg}
                      >
                        <CancelButton
                          icon={'close-circle'}
                          block
                          children={schema?.searchForms?.button?.cancel?.label}
                          onClick={() => {
                            handleCancel()
                          }}
                        />
                      </Col>
                    )}
                  </Row>
                )}
              </Panel>
            </Col>
          </Row>
        )}
      </div>
    </>
  )
}
